import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PlaybookBulkDeleteRemovalStrategy, PlaybookDto } from '../models/playbooks.model';
import { PlaybooksFeature } from './selectors';

export const PlaybooksActions = createActionGroup({
  source: PlaybooksFeature,
  events: {
    'Get Playbooks': emptyProps(),
    'Load Playbooks': emptyProps(),
    'Load Playbooks Fail': emptyProps(),
    'Set Playbooks': props<{ playbooks: PlaybookDto[] }>(),
    'Unlink Clauses From Playbook': props<{ playbook: PlaybookDto; clauseIds: string[] }>(),
    'Unlink Clauses From Playbook Success': props<{ playbook: PlaybookDto }>(),
    'Unlink Clauses From Playbook Fail': emptyProps(),
    'Delete Clauses From Playbook': props<{ playbook: PlaybookDto; clauseIds: string[] }>(),
    'Delete Clauses From Playbook Confirmed': props<{
      playbook: PlaybookDto;
      clauseIds: string[];
    }>(),
    'Delete Clauses From Playbook Success': emptyProps(),
    'Delete Clauses From Playbook Fail': emptyProps(),
    'Delete Clauses From Playbook Cancel': emptyProps(),
    'Delete Playbooks': props<{ playbookIds: string[] }>(),
    'Delete Playbooks Confirmed': props<{
      playbookIds: string[];
      removalStrategy: PlaybookBulkDeleteRemovalStrategy;
      targetPlaybookId?: string;
    }>(),
    'Delete Playbooks Success': emptyProps(),
    'Delete Playbooks Fail': emptyProps(),
    'Delete Playbooks Cancel': emptyProps(),
  },
});
